<template>
  <v-content>
    <div class="px-3 pb-4">
      <v-row align="center" justify="center" no-gutters class="mb-3" :style="{width: baseWidth + 'px', position: basePosition, 'z-index': baseZindex}">
        <v-col cols="2" class="d-flex align-end"><img src="@/assets/delivery_icon.svg"></v-col>
        <v-col cols="5" style="position: relative; left: -15px;">
          <span style="font: bold 13px/22px 'Roboto'; letter-spacing: -0.03em;">Delivery</span>
        </v-col>
        <v-col cols="5" class="text-right" style="font: bold 12px/16px 'Roboto';">
          <v-btn rounded elevation="2" x-small width="120px" height="30px" color="#FFFFFF" class="maincolor"
          @click.stop="$emit('set')"
          >
            すべて表示
          </v-btn>
        </v-col>
      </v-row>

      <v-card :width="parentWidth" :height="parentHeight" class="elevation-6">
        <v-img src="@/assets/delivery_905017_r1@2x.png" @click.stop="$emit('set')"></v-img>
      </v-card>
    </div>
  </v-content>
</template>

<script>
export default {
  props: [],
  data () {
    return {
      baseWidth: 295,
      basePosition: 'relative',
      baseZindex: 3,
      parentHeight: 463,
      parentWidth: 295,
    }
  },
  created() {
    var baseWidth = 295
    var parentHeight = 463
    var parentWidth = 295
    var wh = window.innerHeight
    const isIPad = /iPad|Macintosh/i.test(navigator.userAgent) && 'ontouchend' in document

    if(wh > 590 && isIPad ){
      var raito = wh / 548
      this.baseWidth = baseWidth * raito
      this.parentHeight = parentHeight * raito
      this.parentWidth = parentWidth * raito
    }
  },
  methods: {
  },
}
</script>